@if(error()){
    <div class="error-message">
        {{ error() }}
    </div>
}

@if(siteData().length > 0) {
<div class="sites-toolbar">
    <div class="search-wrapper">
        <input
            type="text"
            class="sites-search-input"
            placeholder="Search sites..."
            [value]="siteSearchTerm()"
            (input)="onSiteSearch($event)"
            aria-label="Search site instances" />
        @if (siteSearchTerm()) {
            <button class="search-clear-btn" (click)="clearSiteSearch()" aria-label="Clear site search" title="Clear search">
                <span>&times;</span>
            </button>
        }
    </div>
    <button 
        class="export-btn" 
        (click)="exportSitesAsCsv()" 
        [disabled]="!isAdmin() || isExportingSites()"
        [title]="isAdmin() ? 'Export all site data' : 'Admin access required to export site data'"
        [attr.aria-label]="isAdmin() ? 'Export all site data' : 'Export disabled - Admin access required'">
        Export CSV
    </button>
</div>
<div class="table-container">
    <div class="table-scroll-container">
        <table class="sites-table" aria-describedby="sites-table">
            <thead>
                <tr>
                    <th class="col-site-name sortable" (click)="toggleSort('name')" (keydown.enter)="toggleSort('name')" tabindex="0"
                        [attr.aria-sort]="sortField() === 'name' ? (sortAscending() ? 'ascending' : 'descending') : null">
                        Site Name
                        @if (sortField() === 'name') {
                            <span class="sort-indicator">{{ sortAscending() ? '&#9650;' : '&#9660;' }}</span>
                        }
                    </th>
                    <th class="col-users sortable" (click)="toggleSort('userCount')" (keydown.enter)="toggleSort('userCount')" tabindex="0"
                        [attr.aria-sort]="sortField() === 'userCount' ? (sortAscending() ? 'ascending' : 'descending') : null">
                        Users
                        @if (sortField() === 'userCount') {
                            <span class="sort-indicator">{{ sortAscending() ? '&#9650;' : '&#9660;' }}</span>
                        }
                    </th>
                    <th class="col-actions text-center">Action</th>
                </tr>
            </thead>
            <tbody>
                @for (site of filteredSortedSiteData(); track site.id) {
                <tr>
                    <td class="col-site-name">{{ site.name }}</td>
                    <td class="col-users">{{ site.userCount ?? 0 }}</td>
                    <td class="col-actions text-center">
                        <div class="action-buttons-group">
                            <button class="view-btn" (click)="loadSiteDetails(site.id)">View</button>
                        </div>
                    </td>
                </tr>
                }
                @if (filteredSortedSiteData().length === 0) {
                <tr>
                    <td colspan="3" class="no-results">No sites match your search.</td>
                </tr>
                }
            </tbody>
        </table>
    </div>
</div>
}

@if(siteData().length === 0 && !error()) {
<div class="no-data">
    No site data available.
</div>
}

<!-- Modal Popup -->
<!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -- modal backdrop dismiss pattern -->
<div class="modal-overlay" [class.open]="isDetailPanelOpen()" (click)="closeDetailPanel()" (keydown)="onModalKeyDown($event)">
    <!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -- stopPropagation on modal content -->
    <div class="modal-content" [class.expanded]="isModalExpanded()" (click)="$event.stopPropagation()" (keydown)="onModalKeyDown($event)">
        <div class="modal-header">
            <h2>{{ selectedSite()?.name || 'Site Details' }}</h2>
            <div class="header-buttons">
                <button class="expand-btn" (click)="toggleModalSize()" [title]="isModalExpanded() ? 'Collapse' : 'Expand'">
                    <span>{{ isModalExpanded() ? '⤢' : '⤡' }}</span>
                </button>
                <button class="close-btn" (click)="closeDetailPanel()">
                    <span>×</span>
                </button>
            </div>
        </div>
        <div class="modal-body">
        @if(selectedSite()) {
            <!-- Tab Navigation -->
            <div class="tab-navigation">
                <button 
                    class="tab-button"
                    [class.active]="isActiveTab('entities')"
                    (click)="setActiveTab('entities')"
                    data-testid="entities-tab-button">
                    Entities ({{ siteEntities().length }})
                </button>
                <button 
                    class="tab-button"
                    [class.active]="isActiveTab('users')"
                    (click)="setActiveTab('users')"
                    data-testid="users-tab-button">
                    Users ({{ siteUsers().length }})
                </button>
            </div>

            <!-- Entities Tab Content -->
            @if (isActiveTab('entities')) {
            <div class="table-section" data-testid="entities-tab-content">
                <div class="admin-table-container">
                    <table class="admin-table" aria-describedby="admin-table">
                        <thead>
                            <tr>
                                <th class="col-entity-name">Entity Name</th>
                                <th class="col-entity-type">Type</th>
                                <th class="col-entity-actions">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (entity of siteEntities(); track $index) {
                            <tr>
                                <td class="col-entity-name entity-name">{{ entity.name }}</td>
                                <td class="col-entity-type entity-type">{{ entity.type }}</td>
                                <td class="col-entity-actions actions">
                                    <button class="action-btn primary" (click)="viewEntity(entity)">View</button>
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            }

            <!-- Users Tab Content -->
            @if (isActiveTab('users')) {
            <div class="table-section" data-testid="users-tab-content">
                <div class="section-header">
                    <div class="search-wrapper">
                        <input
                            type="text"
                            class="users-search-input"
                            placeholder="Search users..."
                            [value]="userSearchTerm()"
                            (input)="onUserSearch($event)"
                            aria-label="Search users" />
                        @if (userSearchTerm()) {
                            <button class="search-clear-btn" (click)="clearUserSearch()" aria-label="Clear user search" title="Clear search">
                                <span>&times;</span>
                            </button>
                        }
                    </div>
                    <button 
                        class="export-btn" 
                        (click)="exportUsersAsCsv()" 
                        [disabled]="!isAdmin() || isExportingSites()"
                        [title]="isAdmin() ? 'Export filtered users to CSV' : 'Admin access required to export user data'"
                        [attr.aria-label]="isAdmin() ? 'Export filtered users to CSV' : 'Export disabled - Admin access required'">
                        Export CSV
                    </button>
                    <button class="action-btn primary" (click)="addUser()">+ Add User</button>
                </div>
                <div class="admin-table-container">
                    <table class="admin-table" aria-describedby="admin-table">
                        <thead>
                            <tr>
                                <th class="col-user-name" scope="col">Name</th>
                                <th class="col-user-email" scope="col">Email</th>
                                <th class="col-user-status" scope="col">Status</th>
                                <th class="col-user-actions" scope="col">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (user of filteredSiteUsers(); track $index) {
                            <tr>
                                <td class="col-user-name user-name">{{ user.displayName }}</td>
                                <td class="col-user-email user-email">{{ user.email }}</td>
                                <td class="col-user-status user-status">{{ getUserStatusText(user.status) }}</td>
                                <td class="col-user-actions actions">
                                    <button class="action-btn primary" (click)="openUserDetail(user)">View Details</button>
                                </td>
                            </tr>
                            }
                            @if (filteredSiteUsers().length === 0 && siteUsers().length > 0) {
                            <tr>
                                <td colspan="4" class="no-results">No users match your search.</td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            }
        } @else {
            <div class="loading-spinner">Loading site details...</div>
        }
        </div>
    </div>
</div>

<!-- User Detail Modal -->
<app-user-detail-modal
  [isOpen]="isUserDetailOpen()"
  [userData]="selectedUserData()"
  (closeModal)="closeUserDetail()"
  (updateUserPermissions)="onUserPermissionsUpdated($event)"
  (deleteUser)="onUserDeleted($event)"
  (userStatusChanged)="onUserStatusChanged($event)"
  (termsReset)="onUserTermsReset($event)"
  (userUpdated)="onUserUpdated($event)">
</app-user-detail-modal>

<!-- Entity Detail Modal -->
<app-entity-detail-modal
  [isOpen]="isEntityDetailOpen()"
  [entityData]="selectedEntityData()"
  (closeModal)="closeEntityDetail()">
</app-entity-detail-modal>

@if (isAddUserModalOpen()) {
<app-add-user-modal 
  [tenantId]="selectedSite()?.tenantId || ''"
  [siteInstanceKey]="selectedSite()?.id || ''"
  (closeModal)="closeAddUserModal()"
  (userAdded)="onUserAdded()">
</app-add-user-modal>
}
